export default "<div class=\"popover {{class}}\" data-binding=\"popover\" {{attrIfValue \"id\" id}}>\n    {{content}}\n</div>\n";